// extracted by mini-css-extract-plugin
export default {"container":"ErrorView_container__1ZrjX","title":"ErrorView_title__GHtNf","text":"ErrorView_text__wcltG"};